(function () {
    'ngInject';

    angular.module('app.shared.services').factory('EPSAPIService', epsAPIService);

    function epsAPIService() {
        return {};
    }
})();
